import React, { useEffect, useState } from "react";
import { DsSpinner } from "../../../design-system";
import { assetService } from "../../../services/api";
import { DASHBOARD_KPI_DEFS } from "./constants";

function readKpi(data, key) {
  if (!data) return 0;
  if (data[key] != null) return Number(data[key]) || 0;
  if (data.kpis?.[key] != null) return Number(data.kpis[key]) || 0;
  if (data.counts?.[key] != null) return Number(data.counts[key]) || 0;
  return 0;
}

export default function AssetDashboardPanel({ onNavigate }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await assetService.getDashboard();
        if (!cancelled) setData(res?.data || res || {});
      } catch (err) {
        if (!cancelled) {
          setData({});
          setError(err?.response?.data?.message || "Could not load dashboard");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <DsSpinner />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="ds-h1 text-[hsl(var(--ds-fg))]">Assets</h1>
        <p className="ds-caption mt-1 text-[hsl(var(--ds-muted-fg))]">
          Inventory overview — click a KPI to open the related view.
        </p>
      </div>
      {error ? (
        <p className="ds-caption text-[hsl(var(--ds-warning))]">{error}</p>
      ) : null}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {DASHBOARD_KPI_DEFS.map((kpi) => {
          const value = readKpi(data, kpi.key);
          return (
            <button
              key={kpi.key}
              type="button"
              onClick={() => onNavigate?.(kpi.tab, kpi.filters)}
              className="rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-4 text-left shadow-[var(--ds-shadow-card)] transition hover:border-[hsl(var(--ds-primary))] focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ds-ring))]"
            >
              <p className="ds-caption text-[hsl(var(--ds-muted-fg))]">{kpi.label}</p>
              <p className="ds-h2 mt-1 text-[hsl(var(--ds-fg))]">{value}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
